import React, {useCallback, useEffect, useState} from "react";
import {connect} from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import Button from "@material-ui/core/Button";
import {Icon} from "../../../comun/Icon/Icon";
import Divider from "@material-ui/core/Divider";
import {openDialogAction} from "../../../comun/DialogManager/DialogManagerAction";
import "./StandList.scss";
import {List, ListActions, ListAvatar, ListContent} from "../../../comun/List/List";
import {CreateStand} from "../CreateStand/CreateStand";
import {deleteStand, getStands,getStandsExcel} from "../StandAction";
import Avatar from "@material-ui/core/Avatar";
import {Grid} from "../../../comun/Grid/Grid";
import {hasRole} from "../../../../auth/util";
import HasRole from "../../../../auth/components/HasRole/HasRole";
import {ManageUser} from "../../ManageUsers/ManageUsers";
import {getCommercialPromoters} from "../../CommercialPromoter/CommercialPromoterAction";
import {StandFilters} from "../StandFilter/StandFilter";
import TouchRipple from "@material-ui/core/ButtonBase/TouchRipple";

export let StandList = ({ onStandDelete, dialogData, onDialogOpen, assignData,assignAction, action, loadFilter= {}, title ='', ...props}) => {
    const getInitialFilter = () => {
        let res = {page: 0, size: 10};
        
        if (dialogData !== undefined) {
            res = Object.assign(dialogData, res);

            if (dialogData.action) {
                action = dialogData.action;
            }
            if (dialogData.title) {
                title = dialogData.title;
            }
        }

        return res;
    }
    
    const [stands, setStands] = useState({content: [], totalPages: 0});
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState(getInitialFilter());
    const [remove,setRemove] = useState(false);
    
    const handleFilters = (vals) => {
        let data = Object.assign({}, vals);
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                data[key] = (data[key] === '') ? null : data[key];
            }
        }
        data = changeFilter(data);
        data.page = 0;
        setPage(1);
        setFilter(data);
    }


    const load = async (filter) => {
        const data = Object.assign(loadFilter, filter);
        await props.onDispatchAction(action, data).then(res => {
            setStands(res);
        })
    }

    const changeFilter =(data) => {
        return Object.assign({}, filter, data);
    };


    const changPage = (event, page) => {
        setPage(page);
        const newFilter = { ...filter, page: page - 1 };
        setFilter(newFilter);
        load(newFilter);
    }

    const openAssignComponent = (user) => {
        assignAction(user, () => load(filter));
    }

    useEffect(() => {
       load(filter);

        return () => setRemove(false);

    }, [filter,remove]);

    const createStand = () => {
        onDialogOpen({component: CreateStand, data: {editting: false}, opened: true, id: "create-stand-dialog", onClose:() => {
            load(filter)
        }});
    };
    const openCommercialPromoters = (stand) => {
        onDialogOpen({component: ManageUser, data: {editting: false, stand: stand.id, action: getCommercialPromoters, rol: 'Promotor'}, opened: true, id: "stand-users-dialog", onClose:() => {
            load(filter)
        }});
    }
    const editStand = (stand) => {
        onDialogOpen({component: CreateStand,  data: {editting: true, id: stand, ...stand}, opened: true, id: "create-stand-dialog",
            onClose: () => {
                load(filter)
            }});
    };
    const isStandOpened =  (status) => {
        return (status === 'OPENED');
    }
    const renderCity = (stand) => {
        return stand.city.name;
    }
    const renderZone = (stand) => {
        if(stand.zone === null){
            return null;
        }

        return <div className="list-content-list-item">
                <h4 className="list-content-list-item-header">Zona</h4>
                <small className="list-content-list-item-subtitle">{stand.zone.name}</small>
            </div>;
    }
    const renderTeamLeader = (stand) => {
        if (stand.city.teamLeader === null) {
            return null;
        }
        return <div className="list-content-list-item">
                <h4 className="list-content-list-item-header">Jefe de equipo Responsable</h4>
                <small className="list-content-list-item-subtitle">{stand.city.teamLeader.name}</small>
            </div>;
    }
    const renderCommercialPromoter = (stand) => {
        if (stand.user) {
            return <div className="list-content-list-item">
                <h4 className="list-content-list-item-header">Comercial Asociado</h4>
                <small className="list-content-list-item-subtitle">{stand.user.name}</small>
            </div>;
        }
        return null;
    }
    return (
        <div className="box">
            <h1>{title}</h1>

            <Grid columns="7fr 1fr" mobileColumns="1fr">
                <div>
                    <StandFilters onSubmit={handleFilters} />
                </div>
                <Pagination count={stands.totalPages} variant="outlined" page={page} shape="rounded" onChange={changPage}/>
            </Grid>
            
            <HasRole role="AREA_COORDINATOR,FL_MANAGER,ADMIN">
            <Button variant="contained" color="secondary" style={{margin: "7px"}} onClick={createStand}>Añadir Stand</Button>
            <Button variant="contained" color="primary" style={{margin: "7px"}} onClick={getStandsExcel}>Descargar Stands</Button>

            <br></br>
            <br></br>
            </HasRole>

            {(stands.content.length === 0) ? <p>No hay ningun stand para mostrar</p> : null}
                {stands.content.map((stand) => {
                    return (
                        <React.Fragment key={stand.id}>
                        <List>
                        <TouchRipple/>
                            <ListAvatar>
                                <Avatar className="list-avatar-container">
                                    <Icon style={{fontSize: "1.6em", color: '#666'}}>house</Icon>
                                </Avatar>
                            </ListAvatar>
                            <ListContent>
                                <h3 className="list-header">{(isStandOpened(stand.status)) ? null : <Icon>lock</Icon>}{stand.mall}</h3>
                                <div className="list-content-list">
                                    <Grid columns="repeat(3, fit-content(200px))" className="list-content-list-columns">
                                    <div className="list-content-list-item">
                                        <h4 className="list-content-list-item-header">Código</h4>
                                        <small className="list-content-list-item-subtitle">{stand.code}</small>
                                    </div>
                                    <div className="list-content-list-item">
                                        <h4 className="list-content-list-item-header">Ciudad</h4>
                                        <small className="list-content-list-item-subtitle">{renderCity(stand)}</small>
                                    </div>
                                    {renderZone(stand)}
                                    {renderTeamLeader(stand)}
                                    </Grid>
                                </div>
                            </ListContent>
                            <HasRole role="AREA_COORDINATOR,FL_MANAGER,ADMIN">
                        <ListActions>

                            <div>
                                <Button onClick={() => {
                                    editStand(stand);
                                }}>
                                    <Icon>edit</Icon> EDITAR
                                </Button>
                            </div>


                            <div>
                                <Button onClick={() => {
                                    openCommercialPromoters(stand);
                                }}>
                                    <Icon>group</Icon> PROMOTORES COMERCIALES
                                </Button>
                            </div>
                            <div>
                                <Button onClick={async () => {
                                    await onStandDelete(stand.id);
                                    setRemove(true);
                                    }}>
                                    <Icon>delete</Icon> BORRAR
                                </Button>
                            </div>

                        </ListActions>
                            </HasRole>
                      </List>
                    <Divider style={{marginTop: '7px', marginBottom: '7px'}} />
                        </React.Fragment>
                    )
                })}
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        
        onDialogOpen: data => {
            dispatch(openDialogAction(data));
        },
        onDispatchAction: async (action, data) => {
            return await action(data)(dispatch);
        },
        onStandDelete: async data => {
           return await deleteStand(data)(dispatch);
        }
    }
}

StandList = connect(null, mapDispatchToProps)(StandList);
